import * as XLSX from "xlsx";
import { _CO, _MONTHS } from "../../../utils/constants";

/**
 * 
 * @param {Array} data 
 * @param {Number} version 
 * @param {String} activity 
 * @param {String} site 
 * @returns 
 */
export const createWorksheet = (data, version, activity, site) => {
  const f = data[0];
  const fiscalYear = f?.fiscalYear || "";

  const [startYear, endYear] = fiscalYear
    .split("-")
    .map((year) => parseInt(year));

  const monthHeaders = [];

  for (let i = 7; i <= 12; i++) {
    monthHeaders.push(`${_MONTHS[i]}/${startYear.toString().slice(-2)}`);
  }

  for (let i = 1; i <= 6; i++) {
    monthHeaders.push(`${_MONTHS[i]}/${endYear.toString().slice(-2)}`);
  }

  const groupedData = {};

  data.forEach((item) => {
    const key = (item.exportNumber ?? "") + item.code;

    if (!groupedData[key]) {
      groupedData[key] = {
        Code: key,
        AccountDescription: item.accountDescription,
        Department: item.department,
        MGT: item.mgt,
      };

      monthHeaders.forEach((monthCol) => {
        groupedData[key][monthCol] = null;
      });
    }

    const fiscalMonth = parseInt(item.fiscalMonth);
    const calendarMonth = _CO[fiscalMonth];

    const year = calendarMonth >= 7 ? startYear : endYear;

    const monthYearKey = `${_MONTHS[calendarMonth]}/${year
      .toString()
      .slice(-2)}`;

    groupedData[key][monthYearKey] = item.amount;
  });

  // Calculate totals
  Object.values(groupedData).forEach((row) => {
    const total = monthHeaders.reduce((sum, month) => {
      return sum + (row[month] || 0);
    }, 0);
    row["Total"] = total;
  });

  const rows = Object.values(groupedData);

  const worksheet = XLSX.utils.json_to_sheet(rows);
  
  // Adjust column widths
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  const wscols = [];
  for (let i = 0; i <= range.e.c; i++) {
    wscols.push({ wch: 15 }); // Set width to 15 characters
  }
  worksheet['!cols'] = wscols;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const fileName = `budget_${activity}_${site}_${fiscalYear}_${version}.xlsx`;
  XLSX.writeFile(workbook, fileName);

  return rows;
};